/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Spaces_Extracted_Text_Empty_DescriptionInputs */



/**
* | output |
* | --- |
* | "This file has no extracted text yet. Re-embed it to generate the extracted Markdown." |
*
* @param {Spaces_Extracted_Text_Empty_DescriptionInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const spaces_extracted_text_empty_description = /** @type {((inputs?: Spaces_Extracted_Text_Empty_DescriptionInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Spaces_Extracted_Text_Empty_DescriptionInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Für diese Datei ist noch kein extrahierter Text vorhanden. Betten Sie sie erneut ein, um das extrahierte Markdown zu erzeugen.")
	return /** @type {LocalizedString} */ ("This file has no extracted text yet. Re-embed it to generate the extracted Markdown.")
});